import {SelectPicker} from "../custom-packages/choicesjs/selectPicker";

enum Gender {
    Male = '0',
    Female = '1',
    Other = '2'
}

export default Gender;

export function getGenderString(type: Gender) {
    switch(type) {
        case Gender.Female:
            return 'Vrouw';
        case Gender.Male:
            return 'Man';
        case Gender.Other:
            return 'Anders';
    }
}

export function getAllGenderOptions(): Array<SelectPicker> {
    return Object.entries(Gender)
        .map(([_, value]) => ({
            value: value as Gender,
            label: getGenderString(value as Gender)
        }));
}
